/**
 * Environment detection utilities.
 *
 * `import.meta.env.PROD` is true for both "staging" and "production" modes by default in Vite.
 * To reliably distinguish environments, we use `import.meta.env.MODE`, which is explicitly
 * set during the build process (e.g., 'production', 'staging').
 * `import.meta.env.DEV` is used for development mode.
 */

export const isProduction = import.meta.env.MODE === "production";
export const isStaging = import.meta.env.MODE === "staging";
export const isDevelopment = import.meta.env.DEV;

export const envName = () => {
  if (isProduction) return "production";
  if (isStaging) return "staging";
  if (isDevelopment) return "development";
  return "unknown";
};
